import React from 'react';
import { Provider } from 'react-redux';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { IntlProvider, addLocaleData } from 'react-intl';
import QueryRenderer from 'relay-query-lookup-renderer';

import { HpRespLayout } from '../homepage/HpRespLayout';
import { homepageRootQuery } from '../queries/homepageRoot';
import serverVars from 'server-vars';
import ReactDOM from 'react-dom';
import { HomePageContextProvider } from '../homepage/HomePageContext';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';
import { defaultLocale } from 'dibs-intl/exports/constants';

initializeDBL().then(({ store }) => {
    if ('ReactIntlLocaleData' in window) {
        const locale = serverVars.get('localeDataKey');
        addLocaleData(window.ReactIntlLocaleData[locale]);
    }

    const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

    ReactDOM.hydrate(
        <IntlProvider
            locale={serverVars.get('locale')}
            defaultLocale={defaultLocale}
            messages={serverVars.get('messages')}
        >
            <HomePageContextProvider
                isMobile={serverVars.get('settings.isMobile')}
                isTablet={serverVars.get('settings.isTablet')}
                isDesktop={serverVars.get('settings.isDesktop')}
                userType={serverVars.get('userType')}
                // userType is only added as a query param for logged-in users
                isLoggedInUser={!!serverVars.get('userType')}
            >
                <Provider store={store}>
                    <QueryRenderer
                        lookup
                        query={homepageRootQuery}
                        variables={serverVars.get('relayVariables')}
                        environment={environment}
                        render={({ error, props }) => {
                            if (error) {
                                return <Error500Layout />;
                            }

                            return <HpRespLayout {...props} />;
                        }}
                    />
                </Provider>
            </HomePageContextProvider>
        </IntlProvider>,
        document.getElementById('js-root')
    );
});
